var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageSent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.256,
    height: 11.141,
    viewBox: "0 0 19.256 11.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Message_Sent",
    "data-name": "Message Sent",
    d: "M14.978,6.265a.838.838,0,0,0-1.211,0l-4.845,4.99L10.133,12.5l4.845-5a.906.906,0,0,0,0-1.239Zm3.642-.009L10.133,15l-2.99-3.07a.838.838,0,0,0-1.211,0,.9.9,0,0,0,0,1.247l3.591,3.7a.838.838,0,0,0,1.211,0l9.1-9.36a.9.9,0,0,0,0-1.247h-.009a.821.821,0,0,0-1.2-.009ZM1.079,13.183l3.591,3.7a.838.838,0,0,0,1.211,0l.6-.619L2.29,11.927a.838.838,0,0,0-1.211,0,.911.911,0,0,0,0,1.256Z",
    transform: "translate(-0.827 -5.999)",
    fill: "#0f7bff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSent);
export default __webpack_public_path__ + "static/media/Message Sent.1b04a22b.svg";
export { ForwardRef as ReactComponent };